CourseGroupListSelectionView = Backbone.View.extend
(
    {
        el: $('.course-groups-selection-list'),

        render: function () {
            let items = this.model;
            let thisEl = this.$el;
            items.each(
                function (item) {
                    let itemView = new CourseGroupSelectionView({model: item});
                    thisEl.append(itemView.render().el);
                }
            );
        }
    }
);
